// extracted by mini-css-extract-plugin
module.exports = {"grey":"#4B5766","blue":"#005CFF","footer":"Footer_footer__3V1cF","container":"Footer_container__2tR68"};